/* rc-contact.js — the reason cards select a subject and take you to the form.

   Each card carries data-subject matching one of the dropdown's options. Click
   it and the select is set, the card marks itself, and focus moves to the form
   so the next thing typed goes in the right place. Without this the cards would
   be three paragraphs someone has to read and then translate into a dropdown
   choice themselves. */
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var cards = [].slice.call(document.querySelectorAll('[data-rc-reason]'));
    var select = document.getElementById('cf-subject');
    if (!cards.length || !select) return;

    function markFromSelect() {
      cards.forEach(function (c) {
        c.classList.toggle('is-active', c.getAttribute('data-subject') === select.value);
      });
    }

    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        var subject = card.getAttribute('data-subject');
        var matched = false;
        [].forEach.call(select.options, function (o) {
          if (o.value === subject) { select.value = o.value; matched = true; }
        });
        // If the label was edited on one side only, do not silently do nothing.
        if (!matched) return;
        markFromSelect();
        var name = document.getElementById('cf-name');
        if (name) {
          name.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setTimeout(function () { name.focus({ preventScroll: true }); }, 350);
        }
      });
    });

    select.addEventListener('change', markFromSelect);
    markFromSelect();
  });
})();
